import React from "react"
import { NavLink } from "react-router-dom"

import styles from "./TestTab.module.css"

function GroupTab({ isFirst, isSecond, isLast }) {
	return (
		<>
			<ul className={styles.testTab}>
				<li>
					<NavLink to="/group-code" style={ isFirst ? { color : 'var(--basic-white)', backgroundColor : 'var(--dark-dark-02)'} : {} }>
						인증코드 생성
					</NavLink>
				</li>
				<li>
					<NavLink to="/group-code/send-waiting" style={ isSecond ? { color : 'var(--basic-white)', backgroundColor : 'var(--dark-dark-02)'} : {} }>
						인증코드 발송대기
					</NavLink>
				</li>
				<li>
					<NavLink to="/group-code/send-complete" style={ isLast ? { color : 'var(--basic-white)', backgroundColor : 'var(--dark-dark-02)'} : {} }>
						인증코드 발송완료
					</NavLink>
				</li>
			</ul>
		</>
	)
}

export default GroupTab
